import { Directive, inject, input } from '@angular/core';
import type { ColumnAlignment } from '../../table-grid/types';
import { HxTableRowDirective } from './table-row';

/**
 * Table cell directive
 *
 * @example
 *   ```html
 *   <hx-table-cell>
 *     Content
 *   </hx-table-cell>
 *   ```;
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'hx-table-cell',
  standalone: true,
  host: {
    class: 'hx-table-cell',
    role: 'cell',
    '[class.hx-table-cell--sticky]': 'sticky()',
    '[class.hx-table-cell--align-left]': 'align() === "left"',
    '[class.hx-table-cell--align-center]': 'align() === "center"',
    '[class.hx-table-cell--align-right]': 'align() === "right"',
    '[style.background-color]': 'getBackgroundColor()',
    '[style.color]': 'getColor()',
  },
})
export class HxTableCellDirective {
  private readonly row = inject(HxTableRowDirective, { optional: true });

  /** Whether cell is sticky */
  readonly sticky = input<boolean>(false);

  /** Content alignment: 'left' | 'center' | 'right' */
  readonly align = input<ColumnAlignment>('left');

  /** Custom background color */
  readonly backgroundColor = input<string>();

  /** Custom text color */
  readonly color = input<string>();

  /** Custom CSS class */

  /** Get effective background color Priority: cell-specific > row-specific > default */
  getBackgroundColor(): string | undefined {
    return this.backgroundColor() || this.row?.backgroundColor();
  }

  /** Get effective text color Priority: cell-specific > row-specific > default */
  getColor(): string | undefined {
    return this.color() || this.row?.color();
  }
}
